@if (gridLabel) {
  <label for="commondate">{{ gridLabel | translate }}</label>
}
<div [class.pt-2]="gridLabel">
  <p-datePicker id="commondate"
                [(ngModel)]="value"
                [disabled]="disabled"
                (change)="updateValue()"
                (onSelect)="updateValue()"
                appendTo="body"
                [showWeek]="showWeek"
                [showIcon]="showIcon"
                class="grid-comp-full-width"
                [dateFormat]="dateFormat"/>
</div>
